import React, { useState } from 'react';

import { ChatContainer, ChatIcon, CloseWrapper } from '../Styles';
import ChatInterface from './ChatInterface';
import {
	ChatHeader,
	MenuButton,
	LogoContainer,
	LogoText,
	BetaTag
} from './ChatInterfaceStyles';
import { ASSET_PATH } from 'assetsPath';
import { FlexDiv } from 'commonStyles';
import { CloseModalIcon } from 'commonStyles';
import { getProfileDataProps, isChatBotEnabled } from 'UtilityComponents/index';
import { getOrgId } from 'UtilityComponents/Util';

const chatConfig = {
	heading: 'Need help?',
	subHeading: 'Connect with your dedicated support manager',
	imgSrc: 'https://jsak.mmtcdn.com/pwa/platform-myra-ui/static/sub_icons/tp-new-animated-with-con.webp?v=2',
	mobileImgSrc: ASSET_PATH.IMAGES + 'mobileChat.png'
};

// Menu dots icon
const MenuDotsIcon = () => (
	<svg width='16' height='4' viewBox='0 0 16 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='2' cy='2' r='2' fill='#1a1a1a' />
		<circle cx='8' cy='2' r='2' fill='#1a1a1a' />
		<circle cx='14' cy='2' r='2' fill='#1a1a1a' />
	</svg>
);

const AiBot = () => {
	const [showBot, setShowBot] = useState(false);
	const [hasInteracted, setHasInteracted] = useState(false);

	if (!isChatBotEnabled(getOrgId(), getProfileDataProps('mmtUuid'))) {
		return null;
	}

	const setBot = () => {
		setHasInteracted(true);
		setShowBot(true);
	};

	const handleClose = () => {
		setShowBot(false);
	};

	const userName = getProfileDataProps('name') || 'there';

	return (
		<ChatContainer
			showBot={showBot}
			hasInteracted={hasInteracted}
			$direction='column'
			justify='flex-start'>

			{!showBot ? (
				<FlexDiv $width='100%' padding='0' align='center' justify='center' height='100%'>
					<ChatIcon
						onClick={setBot}
						src={chatConfig.imgSrc}
						alt='Chat with Myra'
					/>
				</FlexDiv>
			) : (
				<>
					<ChatHeader>
						<MenuButton>
							<MenuDotsIcon />
						</MenuButton>
						<LogoContainer>
							<LogoText>myra.AI</LogoText>
							<BetaTag>beta</BetaTag>
						</LogoContainer>
						<CloseWrapper onClick={handleClose}>
							<CloseModalIcon />
						</CloseWrapper>
					</ChatHeader>
					<ChatInterface userName={userName} />
				</>
			)}
		</ChatContainer>
	);
};

export default AiBot;
